import React from "react";
import { ArrowDownIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { finalFlow } from "../../data/framework";
export function FinalCtaSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-156" data-mp="2ijrbgrpxgrpg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-157" data-mp="2dibogu46wb4f">
        <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-gold sm:text-sm" data-id="element-158" data-mp="2dlpovwtama98">Your Next Step</p>
        <h2 className="mt-3 text-[28px] font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-159" data-mp="2mkb5vnj49h7w">
          You Don't Need Another Collection of Disconnected Orthodontic Information.
        </h2>
        <p className="mt-4 text-xl font-bold text-sky sm:text-2xl" data-id="element-160" data-mp="2wa4k6wan8afu">
          You Need a Clearer Way to Understand How the Concepts Fit Together.
        </p>

        <p className="mt-8 text-base text-white/80 sm:text-lg" data-id="element-161" data-mp="3a9vqsbytyojt">Imagine having one organized reference where you can review:</p>
        <ol className="mx-auto mt-5 flex max-w-sm flex-col items-center" data-id="element-162" data-mp="220krp1fj609r">
          {finalFlow.map((step, i) => <li key={step} className="flex w-full flex-col items-center" data-id="element-163" data-mp="261mq5g1mi8ao" data-mpi={i}>
              <span className="w-full rounded-xl border border-white/15 bg-navy-800 px-4 py-3 text-base font-extrabold text-white" data-id="element-164" data-mp="263zgaghjboyt">
                {step}
              </span>
              {i < finalFlow.length - 1 && <ArrowDownIcon className="my-1.5 h-5 w-5 text-gold" aria-hidden="true" data-id="element-165" data-mp="2kzf443riuomr" />}
            </li>)}
        </ol>

        <p className="mt-8 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-166" data-mp="2p08s0x4ys3fn">
          All within one connected educational system. No more searching through scattered materials just to understand how
          different concepts relate to one another.
        </p>
        <p className="mt-3 text-lg font-black text-white" data-id="element-167" data-mp="33pwwu8cctk84">Build a stronger foundation for studying self-ligating orthodontics.</p>

        <div className="mt-10 rounded-3xl bg-white p-6 sm:p-10" data-id="element-168" data-mp="38o87glah3yre">
          <p className="text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-169" data-mp="2j0vo5uto3phi">
            Get the Complete Self-Ligating Orthodontics Blueprint™
          </p>
          <p className="mt-1 text-[15px] text-ink-muted" data-id="element-170" data-mp="2e3c7ko9hz0me">6 Specialized Clinical Volumes + 5 Professional Bonuses</p>
          <p className="mt-4 text-sm font-bold uppercase text-ink-muted" data-id="element-171" data-mp="2sss0a9sl9g4q">Only</p>
          <p className="text-7xl font-black leading-none tracking-tight text-brand" data-id="element-172" data-mp="2nye25zmjkuwd">
            $27<span className="ml-1 text-2xl text-ink" data-id="element-173" data-mp="31q28fma40p5f">USD</span>
          </p>

          <div className="mt-6 flex flex-col items-center gap-3" data-id="element-174" data-mp="2wt21za9clkds">
            <CtaButton label="Yes! I Want the Complete Blueprint™" className="sm:w-full" data-id="element-175" data-mp="3bpjdc1hjez0c" />
            <p className="text-xs font-medium text-ink-muted sm:text-sm" data-id="element-176" data-mp="3bn6y3w35z2qz">
              Immediate Digital Access · Lifetime Access · One-Time Payment
            </p>
            <p className="flex items-center gap-1.5 text-xs font-semibold text-success sm:text-sm" data-id="element-177" data-mp="1hc1z5530vehz">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-178" data-mp="1ce06ptjpi2tu" />
              7-Day Satisfaction Guarantee — subject to the published policy
            </p>
          </div>

          <div className="mt-6" data-id="element-179" data-mp="3sxu3vo8brl4y">
            <Countdown label="Special promotional price ends in:" data-id="element-180" data-mp="3t0yep4gapf4l" />
          </div>
        </div>

        <p className="mt-10 text-xl font-black uppercase leading-snug text-white sm:text-2xl" data-id="element-181" data-mp="3e9pksj5d17ln">
          Start exploring self-ligating orthodontics with a clearer clinical framework.
        </p>
        <div className="mx-auto mt-6 max-w-xl" data-id="element-182" data-mp="357zslb3nm4mt">
          <CtaButton label="Get Instant Access for $27" data-id="element-183" data-mp="39be9e3zf2p1b" />
        </div>
      </div>
    </section>;
}